import React, { useState, useRef } from 'react';
import './Contact.css';
import ContactApp from './programs/ContactApp';

function Contact() {
  const [formStep,   setFormStep]   = useState('email');
  const [formStatus, setFormStatus] = useState('');
  const appRef = useRef(null);

  // Show "Try again" once email was accepted (step advanced) or on submission error
  const showTryAgain = formStep !== 'email' || formStatus === 'error';

  return (
    <section className="contact" id="contact">
      <div className="contact-wrap">
        <p className="section-label">
          <span className="section-prompt">&gt;</span> Contact
        </p>

        <div className="contact-panel">
          {/* Title bar */}
          <div className="contact-panel-bar">
            <span className="hero-panel-dot" />
            <span className="hero-panel-dot" />
            <span className="hero-panel-dot" />
            <span className="hero-panel-label">user@southlabs: /contact_us</span>
            {showTryAgain && (
              <button
                className="contact-reset-btn"
                onClick={() => {
                  appRef.current?.reset();
                  setFormStep('email');
                  setFormStatus('');
                }}
              >
                Try again
              </button>
            )}
          </div>

          {/* App body — ContactApp renders boot + form */}
          <div className="contact-panel-body" onClick={() => appRef.current?.focus()}>
            <ContactApp
              ref={appRef}
              onStepChange={(step, status) => {
                setFormStep(step);
                setFormStatus(status);
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
